import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { HealthCheck } from '../components/health-check/models/health-check.model';
import { parseHealthCheckResponse } from '../components/health-check/utils/helpers';
import { ApiLog } from '../models/api-log';
import { LogSearchCriteria } from './../models/log-search-criteria.model';

@Injectable()
export class ApiLogsService {
  apiLogForDetails: ApiLog;

  constructor(
    private http: HttpClient
  ) { }

  getApiUrlByName(apiName: string) {
    switch (apiName) {
      case 'Communications':
        return environment.communicationApiURL;
      case 'Risk':
        return environment.riskApiURL;
      case 'Identity':
        return environment.identityApiUrl;
      case 'JMIdentity':
        return environment.jmIdentityApiUrl;
      case 'Content':
        return environment.contentApiURL;
      case 'Membership':
        return environment.membershipApiUrl;
      case 'Billing':
        return environment.billingApiURL;
      case 'Shipping':
        return environment.shippingApiURL;
      case 'Payment':
        return environment.paymentApiURL;
      case 'Document':
        return environment.documentApiUrl;
      case 'Account':
        return environment.accountApiUrl;
      case 'Reporting':
        return environment.reportingApiUrl;
      case 'ShoppingCart':
        return environment.shoppingCartApiUrl;
      case 'Appraisals':
        return environment.appraisalApiURL;
      case 'Marketplace':
        return environment.marketplaceApiURL;
      case 'PointOfSaleIntegration':
        return environment.pointOfSaleIntegrationApiUrl;
      case 'Memo':
        return environment.memoApiUrl;
      case 'JewelerPages':
        return environment.jewelerPagesApiUrl;
      case 'Auction':
        return environment.auctionApiUrl;
      default:
        return '';
    }
  }

  getApiLogs(apiName: string, partitionKey: string, rowKey: string) {
    const url = `${this.getApiUrlByName(apiName)}/api/Logs/search`;
    const searchCriteria = new LogSearchCriteria();
    searchCriteria.Filter = '';
    searchCriteria.PageSize = 10;
    searchCriteria.RowKey = '';
    searchCriteria.PartitionKey = '';

    if (partitionKey && rowKey) {
      searchCriteria.RowKey = rowKey;
      searchCriteria.PartitionKey = partitionKey;
    }

    return this.http.post(url, searchCriteria);
  }

  getHealthCheckInfo(apiName: string): Observable<HealthCheck> {
    const url = `${this.getApiUrlByName(apiName)}/hc`;
    return this.http
      .get(url, { responseType: 'text' })
      .pipe(map(raw => parseHealthCheckResponse(raw)));
  }
}
